import { RenderIf, LiabilityFileUpload } from '../index';
import { LIABILITY_FILES_KEY_MAP, getLiabilityFileKeysForCaseType } from '@demandproai/shared';
import { useAddCaseFormContext } from '../../contexts/AddCaseFormContext';
import { TOUR_TARGETS } from '../../constants/tourTargets';

const UPLOAD_BUTTON_TEXT_BY_KEY = {
  witnessStatements: 'Upload Statement'
};

const DEFAULT_UPLOAD_BUTTON_TEXT = 'Upload Report';

// Renders liability report file upload sections
const CaseLiabilityReports = () => {
  const { formik } = useAddCaseFormContext();
  const caseType = formik.values.caseInfo?.caseType;
  const fileKeys = getLiabilityFileKeysForCaseType({ caseType });

  return (
    <div className="row mb-10!" data-tour={TOUR_TARGETS.LIABILITY_REPORTS}>
      <div className="col-md-12">
        <div className="form-group flex flex-col gap-4">
          {Object.values(LIABILITY_FILES_KEY_MAP).map(({ key, text }) => (
            <RenderIf key={key} shouldRender={fileKeys.includes(key)}>
              <LiabilityFileUpload
                fileType={key}
                label={text}
                uploadButtonText={UPLOAD_BUTTON_TEXT_BY_KEY[key] ?? DEFAULT_UPLOAD_BUTTON_TEXT}
              />
            </RenderIf>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaseLiabilityReports;
